<template>
  <div v-bem class="container">
    <h2 class="title">{{$t('guarantees.title')}}</h2>
    <div class="row reorder">
      <div class="col-6 second">
        <div v-bem:item class="row">
          <div class="col-2">
            <div v-bem:item:icon><img src="@/assets/img/icons/money.svg" alt=""></div>
          </div>
          <div class="col-10"><div v-bem:item:text v-html="$t('guarantees.item1')"></div></div>
        </div>
        <div v-bem:item class="row">
          <div class="col-2">
            <div v-bem:item:icon><img src="@/assets/img/icons/chat.svg" alt=""></div>
          </div>
          <div class="col-10"><div v-bem:item:text v-html="$t('guarantees.item2')"></div></div>
        </div>
        <div v-bem:item class="row">
          <div class="col-2">
            <div v-bem:item:icon><img src="@/assets/img/icons/smile.svg" alt=""></div>
          </div>
          <div class="col-10"><div v-bem:item:text v-html="$t('guarantees.item3')"></div></div>
        </div>
        <div v-bem:item class="row">
          <div class="col-2">
            <div v-bem:item:icon><img src="@/assets/img/icons/sheild.svg" alt=""></div>
          </div>
          <div class="col-10"><div v-bem:item:text v-html="$t('guarantees.item4')"></div></div>
        </div>
      </div>
      <div v-bem:image class="col-6 first">
        <img src="@/assets/img/guarantees.png" alt="nos garanties">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Guarantees'
}
</script>

<style scoped lang="scss">
.guarantees {
  &__item {
    margin: rem(20) auto;
    max-width: 90%;
    &-icon {
      position: relative;
      width: rem(80);
      height: rem(80);
      background-color: rgba(var(--primary-color), 1);
      img {
        @extend %transform-center;
        max-width: rem(30);
      }
    }
    &-text {
      h3 {
        font-family: var(--primary-font-bold);
        font-weight: normal;
        @include font-size(18);
      }
      p {
        @include font-size;
        margin: rem(10) 0;
        text-align: justify;
      }
    }
  }
  &__image {
    text-align: center;
    padding-top: rem(120);
    img {
      width: rem(600);
      max-width: 90%;
    }
  }
  @include breakpoint(1180) {
    &__item {
      max-width: 100%;
    }
  }
  @include breakpoint('charmeleon') {
    &__item {
      &-icon {
        width: rem(60);
        height: rem(60);
        img {
          height: rem(30);
        }
      }
    }
    &__image {
      padding-top: rem(200);
    }
  }
  @include breakpoint(800) {
    &__image {
      padding-top: rem(120);
    }
  }
  @include breakpoint('charmander') {
    &__item {
      text-align: center;
      margin-bottom: rem(40);
      &-icon {
        width: rem(80);
        height: rem(80);
        margin: 0 auto;
      }
      &-text {
        padding-top: rem(10);
        h3 {
          @include font-size(22);
        }
        p {
          text-align-last: center;
          @include font-size;
        }
      }
    }
    &__image {
      padding-top: 0;
    }
  }
}
</style>